<div class="cg-flex cg-flex-vertical-center">
  <section class="content-section">
    <div>
      <h4 class="cg-subhead-4 cg-callout-header">
        <span data-test="new-features-title">{{
          'dashboard.latestUpdateTile.newFeatures' | translate
        }}</span>
      </h4>
      <div class="cg-margin-top-md" data-test="new-features-content">
        <div class="cg-margin-top-md" *ngFor="let feature of features">
          <button
            cignaButton="link"
            style="padding: 0; text-align: left"
            (click)="open(feature)"
          >
            {{ feature.title }}
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
